<template>
  <div>
    <AppSelect
      :value="value"
      :options="angezeigteOptions"
      :loading="isLoading"
      :multiple="isMultipleAllowed"
      :internal-search="false"
      :dropup="openDirection === 'top'"
      :disabled="disabled"
      :style="cssProps"
      label="Countrymanager"
      placeholder="Countrymanager suchen…"
      empty-text="Tippen um Countrymanager zu suchen…"
      no-results-text="Keine Countrymanager gefunden"
      @search-change="onSearch"
      @input="$emit('input', $event)"
    />
  </div>
</template>

<script>
import AppSelect from '@/components/common/app-select/app-select.vue';
import apiService from '@/core/common/services/api.service';

export default {
  components: {
    AppSelect,
  },
  props: {
    value: { type: Array, default: () => [] },
    isMultipleAllowed: { type: Boolean, default: true },
    isChangedMetadata: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    openDirection: { type: String, default: '' },
  },
  data() {
    return {
      options: [],
      isLoading: false,
      // Timer, der die Suche um 500ms verzögert, damit nicht bei jedem Tastendruck gesucht wird
      sucheVerzoegerungsTimer: null,
      // Fortlaufende Nummer je Suche, um veraltete Antworten zu erkennen
      letzteSucheNummer: 0,
      // Controller zum Abbrechen einer noch laufenden Server-Anfrage
      laufendeSucheAbbrechen: null,
    };
  },
  methods: {
    // Stößt eine verzögerte Suche an und verwirft dabei ältere, noch nicht gestartete oder laufende Suchen
    onSearch(suchtext) {
      if (this.sucheVerzoegerungsTimer) {
        clearTimeout(this.sucheVerzoegerungsTimer);
        this.sucheVerzoegerungsTimer = null;
      }
      if (this.laufendeSucheAbbrechen) {
        this.laufendeSucheAbbrechen.abort();
        this.laufendeSucheAbbrechen = null;
      }

      if (!suchtext) {
        this.options = [];
        this.isLoading = false;
        return;
      }

      this.sucheVerzoegerungsTimer = setTimeout(() => {
        this.ladeCountrymanager(suchtext);
      }, 500);
    },
    ladeCountrymanager(suchtext) {
      this.isLoading = true;

      // Jede Suche bekommt eine eigene Nummer, um zu erkennen ob eine Antwort noch aktuell ist
      const sucheNummer = ++this.letzteSucheNummer;
      const abbruch = new AbortController();
      this.laufendeSucheAbbrechen = abbruch;

      const url = `CountryManager?$filter=startswith(countryManagerKuerzel,'${suchtext}')&$select=countryManagerKuerzel&$top=50`;

      apiService
        .get(url, '', { signal: abbruch.signal })
        .then(res => {
          // Ist inzwischen eine neuere Suche gestartet, gehört diese Antwort zu einer alten Eingabe
          if (sucheNummer !== this.letzteSucheNummer) {
            return;
          }
          const eintraege = res.data?.result?.value || [];
          const kuerzel = eintraege.map(cm => cm.countryManagerKuerzel).filter(Boolean);
          this.options = [...new Set(kuerzel)].sort((a, b) => a.localeCompare(b));
        })
        .catch(error => {
          // Eine absichtlich abgebrochene Anfrage ist kein Fehler
          if (error.code === 'ERR_CANCELED') {
            return;
          }
          console.error('Fehler bei der Countrymanager-Suche:', error);
        })
        .finally(() => {
          if (sucheNummer === this.letzteSucheNummer) {
            this.isLoading = false;
          }
        });
    },
  },
  computed: {
    // Die gewählten Kürzel werden ergänzt, damit sie auch ohne Suchtreffer im Feld stehen bleiben
    angezeigteOptions() {
      const kuerzel = new Set(this.options);
      (Array.isArray(this.value) ? this.value : [this.value]).filter(Boolean).forEach(eintrag => {
        kuerzel.add(eintrag);
      });
      return [...kuerzel];
    },
    cssProps() {
      return {
        '--app-select-background': this.isChangedMetadata
          ? '#3699FF50'
          : this.disabled
          ? '#F3F6F9'
          : '#ffffff',
      };
    },
  },
};
</script>
